<template>
  <div>
    <div class="pricing_banner">
      <figure>
        <div>
          <h1>Pricing</h1>
          <p>We have pricing options available for every church.</p>
        </div>
      </figure>
    </div>

    <div class="main_content">
      <div class="how_it_work_main">
        <div class="container">
          <div class="how_it_work col-12 col-sm-10 col-md-10">
            <h3>Join Today and get access to the complete video library right away!</h3>
            <div class="how_it_work_cnt">
              <p>Our subscriptions work like Netflix. If you signup for a yearly plan, you will get a great discount. Monthly plans can be canceled any time.</p>
            </div>
            <div class="care_left">
              <a href="javascript:void(0)" tabindex="0">Learn How TLC Works</a>
            </div>
          </div>
        </div>
      </div>
      <div class="pricing_list_main">
        <div class="container pricing_list">
          <div class="header">
            <div class="column-1">Members</div>
            <div class="column-2">Monthly</div>
            <div class="column-3">Yearly (Save 16%!)</div>
          </div>
          <div class="content">
            <div :class="`content-${ind % 2 === 0 ? 'odd' : 'even'}`" v-for="(item, ind) in dataList" :key="ind">
              <div class="column-1">{{ item.member }}</div>
              <div class="column-2 care_left">
                <a href="javascript:void(0)" v-text="item.needToCall ? 'Call for qoute' : `$${item.monthly}`" @click="!item.needToCall ? selectPlan(item, 'month') : callnumber()"></a>
              </div>
              <div class="column-3 care_left">
                <a href="javascript:void(0)" v-text="item.needToCall ? 'Call for qoute' : `$${item.yearly}`" @click="!item.needToCall ? selectPlan(item, 'year') : callnumber()"></a>
              </div>
            </div>
          </div>
        </div>
        <div class="container pricing_list-small">
          <div class="content">
            <div :class="`content-${ind % 2 === 0 ? 'odd' : 'even'} noHover`" v-for="(item, ind) in dataList" :key="ind">
              <b>Members</b>
              <div class="column-1">{{ item.member }}</div>
              <b>Monthly</b>
              <div class="column-2 care_left">
                <a href="javascript:void(0)" v-text="item.needToCall ? 'Call for qoute' : `$${item.monthly}`" @click="!item.needToCall ? selectPlan(item, 'month') : callnumber()" />
              </div>
              <b>Yearly (Save 16%!)</b>
              <div class="column-3 care_left">
                <a href="javascript:void(0)" v-text="item.needToCall ? 'Call for qoute' : `$${item.yearly}`" @click="!item.needToCall ? selectPlan(item, 'year') : callnumber()" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Pricing',
  data: () => ({
    dataList: [
      {
        member: '0-49',
        monthly: '29.99',
        yearly: '299.00',
        planMonthly: '49monthlycounseling',
        planYearly: '49yearlycounseling'
      },
      {
        member: '50-99',
        monthly: '39.99',
        yearly: '399.00',
        planMonthly: '99monthlycounseling',
        planYearly: '99yearlycounseling'
      },
      {
        member: '100-199',
        monthly: '65.99',
        yearly: '659.00',
        planMonthly: '199monthlycounseling',
        planYearly: '199yearlycounseling'
      },
      {
        member: '200-349',
        monthly: '85.99',
        yearly: '859.00',
        planMonthly: '349monthlycounseling',
        planYearly: '449yearlycounseling'
      },
      {
        member: '350-499',
        monthly: '115.99',
        yearly: '1159.00',
        planMonthly: '499monthlycounseling',
        planYearly: '499yearlycounseling'
      },
      {
        member: '500-749',
        monthly: '149.99',
        yearly: '1499.00',
        planMonthly: '749monthlycounseling',
        planYearly: '749yearlycounseling'
      },
      {
        member: '750-999',
        monthly: '199.99',
        yearly: '1999.00',
        planMonthly: '999monthlycounseling',
        planYearly: '999yearlycounseling'
      },
      {
        member: '1,000-1,499',
        monthly: '235.99',
        yearly: '2359.00',
        planMonthly: '1499monthlycounseling',
        planYearly: '1499yearlycounseling'
      },
      {
        member: '1,500-1,999',
        monthly: '265.99',
        yearly: '2659.00',
        planMonthly: '1999monthlycounseling',
        planYearly: '1999yearlycounseling'
      },
      {
        member: '2,000-2,499',
        monthly: '299.99',
        yearly: '2999.00',
        planMonthly: '2499monthlycounseling',
        planYearly: '2499yearlycounseling'
      },
      {
        member: '2,500',
        needToCall: true
      }
    ]
  }),
  methods: {
    callnumber() {
      alert('Please Call (800) 749-0570 For Pricing')
    },
    selectPlan(plan, type) {
      $.cookie('monthly', plan.monthly, { expires: 7, path: '/', sameSite: 'none' })
      $.cookie('yearly', plan.yearly, { expires: 7, path: '/', sameSite: 'none' })
      $.cookie('planMonthly', plan.planMonthly, { expires: 7, path: '/', sameSite: 'none' })
      $.cookie('planYearly', plan.planYearly, { expires: 7, path: '/', sameSite: 'none' })
      $.cookie('plancycle', type, { expires: 7, path: '/', sameSite: 'none' })
      this.$router.push({ name: 'checkout' })
    }
  }
}
</script>
<style lang="scss">
.pricing_banner {
  position: relative;
  z-index: 2;
  figure {
    background-size: cover;
    background-repeat: no-repeat;
    background-color: rgba(0, 0, 0, 0);
    background-image: url('/images/pricing.jpg');
    background-attachment: scroll;
    background-position: center center;
    div {
      text-align: center;
      padding: 50px 35px;
      background-color: rgba(51, 51, 51, 0.4);
    }
    img {
      width: 100%;
    }
  }
}
.how_it_work_main {
  background: rgb(243, 243, 243) none repeat scroll 0% 0%;
  text-align: center;
  .how_it_work {
    padding: 35px 15px;
    color: #3b3f4a;
    margin: auto;
    h3 {
      font: 300 25px / 36px 'Poppins', sans-serif;
    }
    .how_it_work_cnt {
      padding: 35px 0;
      p {
        font: 300 15px / 28px 'Poppins', sans-serif;
        word-spacing: normal;
        color: #787d85;
      }
    }
  }
  .care_left {
    padding: 0;
    a {
      margin: auto;
      background: #555;
      border-color: transparent;
    }
  }
}
.pricing_list_main {
  .pricing_list {
    padding: 35px 50px;
    &-small {
      display: none;
    }
    .header {
      .column-1,
      .column-2 {
        background-color: #333;
      }
      .column-3 {
        background: #2ba349;
      }
    }

    .header,
    .content > div {
      display: flex;
      > div {
        line-height: 55px;
        padding-left: 20px;
      }
    }
    &-small .content,
    .header,
    .content {
      .column-1,
      .column-2 {
        flex: 2;
      }
      .column-3 {
        background-color: #4bbc67;
        flex: 3;
      }
    }

    &-small .content,
    .content {
      .column-3,
      .column-2 {
        &.care_left {
          padding: 0;
          padding-left: 20px;
          a {
            background: #2ba048;
            border-color: transparent;
            padding: 0 10px;
            line-height: 26px;
            height: 30px;
            border-radius: 15px;
            width: initial;
            min-width: 120px;
            vertical-align: middle;
            display: inline-block;
          }
        }
      }
      &-odd {
        background-color: #e0e0e0;
      }
      &-even {
        background-color: #fff;
        .column-3 {
          background-color: rgba(74, 210, 108, 0.7);
        }
      }
      &-odd,
      &-even {
        color: #787d85;
        &:not(.noHover):hover,
        &:not(.noHover):hover .column-3 {
          background-color: #f3f3f3;
        }
        &:not(.noHover):hover {
          color: #2ba048;
          font-weight: bold;
          font-size: 20px;
          height: 75px;
          line-height: 75px;
          > div {
            line-height: 75px;
          }
        }
      }
    }
    @media only screen and (max-width: 767px) {
      display: none;
      &-small {
        display: block;
        .content {
          display: flex;
          flex-direction: column;
        }
        .content {
          .column-3 {
            background-color: transparent;
          }
          .noHover {
            > div.care_left {
              padding-left: 10px;
            }
            b,
            > div {
              display: block;
              padding: 10px;
              padding-top: 0;
              &:first-child {
                padding-top: 10px;
              }
              &.column-1 {
                padding-bottom: 0;
              }
            }
            > div {
              margin-bottom: 20px;
            }
          }
        }
      }
    }
  }
}
</style>
